import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetail from './components/ProjectDetail/ProjectDetail';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import './styles/global.css';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/50432131921"
    className="whatsapp-fab"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contactar por WhatsApp"
  >
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M16 2C8.268 2 2 8.268 2 16c0 2.522.658 4.89 1.81 6.94L2 30l7.294-1.782A13.94 13.94 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2Z" fill="white"/>
      <path d="M22.003 19.275c-.32-.16-1.89-.932-2.183-1.038-.293-.107-.507-.16-.72.16-.214.32-.827 1.038-.973 1.197-.16.16-.306.18-.613.02-.32-.16-1.344-.495-2.56-1.58-.946-.845-1.585-1.888-1.77-2.208-.187-.32-.02-.493.14-.652.145-.143.32-.373.48-.56.16-.186.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.732-.986-2.373-.26-.624-.52-.54-.72-.55-.186-.008-.4-.01-.613-.01-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667s1.147 3.093 1.307 3.307c.16.213 2.253 3.44 5.46 4.826.763.33 1.36.527 1.823.674.766.243 1.464.208 2.016.126.615-.091 1.89-.773 2.156-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373Z" fill="#25D366"/>
    </svg>
  </a>
);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/proyectos" element={<ProjectsPage />} />
        <Route path="/proyectos/:id" element={<ProjectDetail />} />
        <Route path="/privacidad" element={<PrivacyPage />} />
        <Route path="/terminos" element={<TermsPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <WhatsAppButton />
    </BrowserRouter>
  );
};

export default App;
